export const MWEB_MINWIDTH = 750;

export const ProductShape = {
	RectangleA: {
		height: "11rem",
	},
	RectangleB: {
		height: "14.75rem",
	},
};
